__turbopack_context__.v({
  "className": "caveat_d0714daf-module__9W5_2W__className",
});
